/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';

import DeleteProfileButton from './DeleteProfileButton/DeleteProfileButton';
import ApproveProfileButton from './ApproveProfileButton/ApproveProfileButton';

/**
 * This is the Debug component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class Debug extends Component {
  /**
   * Render Debug.
   *
   * @return {Object}
   */
  render() {
    return (
      <ul>
        <li>
          <ApproveProfileButton />
        </li>
        <li>
          <DeleteProfileButton />
        </li>
      </ul>
    );
  }
}
